import ActionTypes from '../../../../ActionsTypes';
export function fetchData(id, pathname, saveData) {
  return {
    type: ActionTypes.GET_DATA,
    payload: {
      id: id,
      pathname: pathname,
      saveData: saveData
    }
  };
}
export function addEntry(countryID, plotID, key, value) {
  return {
    type: ActionTypes.ADD_ENTRY,
    payload: {
      countryID: countryID,
      plotID: plotID,
      key: key,
      value: value
    }
  };
}
export function setCurrentData(countryID, plotID, key) {
  return {
    type: ActionTypes.SET_CURRENT_DATA,
    payload: {
      countryID: countryID,
      plotID: plotID,
      key: key
    }
  };
}